(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~menu~select~table~tree~treeSelect"],{

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wrapWithConnect; });
/* harmony import */ var babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vue_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _props_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function getDisplayName(WrappedComponent) {
  return WrappedComponent.name || 'Component';
}

function wrapWithConnect(WrappedComponent) {
  var tempProps = WrappedComponent.props || {};
  var methods = WrappedComponent.methods || {};
  var props = {};
  Object.keys(tempProps).forEach(function (k) {
    props[k] = _objectSpread(_objectSpread({}, tempProps[k]), {}, {
      required: false
    });
  });
  WrappedComponent.props.__propsSymbol__ = _vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].any;
  WrappedComponent.props.children = _vue_types__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].array.def([]);
  var ProxyWrappedComponent = {
    props: props,
    model: WrappedComponent.model,
    name: "Proxy_".concat(getDisplayName(WrappedComponent)),
    methods: {
      getProxyWrappedInstance: function getProxyWrappedInstance() {
        return this.$refs.wrappedInstance;
      }
    },
    render: function render() {
      var h = arguments[0];
      var _this$$slots = this.$slots,
          $slots = _this$$slots === void 0 ? {} : _this$$slots,
          $scopedSlots = this.$scopedSlots;
      var props = Object(_props_util__WEBPACK_IMPORTED_MODULE_2__["getOptionProps"])(this);
      var wrapProps = {
        props: _objectSpread(_objectSpread({}, props), {}, {
          __propsSymbol__: Symbol(),
          componentWillReceiveProps: _objectSpread({}, props),
          children: $slots.default || props.children || []
        }),
        on: Object(_props_util__WEBPACK_IMPORTED_MODULE_2__["getListeners"])(this)
      };

      if (Object.keys($scopedSlots).length) {
        wrapProps.scopedSlots = $scopedSlots;
      }

      var slotsKey = Object.keys($slots);
      return h(WrappedComponent, babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0___default()([wrapProps, {
        ref: "wrappedInstance"
      }]), [slotsKey.length ? slotsKey.map(function (name) {
        return h("template", {
          slot: name
        }, [$slots[name]]);
      }) : null]);
    }
  };
  /* eslint-disable */

  Object.keys(methods).map(function (m) {
    ProxyWrappedComponent.methods[m] = function () {
      var _this$getProxyWrapped;

      return (_this$getProxyWrapped = this.getProxyWrappedInstance())[m].apply(_this$getProxyWrapped, arguments);
    };
  });
  return ProxyWrappedComponent;
}

/***/ })

}]);